import React from 'react';
import InputMask from 'react-input-mask';
import unpick from "../../../utilities/unpick";

const InputMaskWrap = (props) => {
 const p =  unpick(props.children.props, [
   'onPaste',
   'onInput',
   'onKeyPress',
   'onKeyDown',
   'onKeyUp'
 ]);

  return <InputMask {...p} />;
};

export default InputMaskWrap;